var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "box" }, [
    _c("h1", { staticClass: "title is-4" }, [_vm._v("Opciones para RRHH")]),
    _vm._v(" "),
    _c("div", { staticClass: "buttons my-2" }, [
      _c(
        "a",
        {
          staticClass: "button is-primary is-fullwidth",
          on: {
            click: function ($event) {
              return _vm.$emit("selectScope", "current")
            },
          },
        },
        [
          _c("i", { staticClass: "fas fa-upload fa-fw" }),
          _vm._v(" Subir documentos con "),
          _c("b", [_vm._v("Firmador v3 ®")]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }